import _defineProperty2 from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import React, { Component } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Cache =
/*#__PURE__*/
function () {
  function Cache() {
    var cacheSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CACHE_SIZE;

    _classCallCheck(this, Cache);

    _defineProperty(this, "_cache", new Map([]));

    this.cacheSize = cacheSize;
  }

  _createClass(Cache, [{
    key: "get",
    value: function get(key) {
      return this._cache.get(key);
    }
  }, {
    key: "set",
    value: function set(key, results) {
      this._cache.set(key, results);
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this._cache.clear();
    }
  }, {
    key: "setPendingResult",
    value: function setPendingResult(graphqlQuery, promise) {
      var cache = this._cache; //front of the line now, to support LRU ejection

      if (!this.noCaching) {
        cache.delete(graphqlQuery);

        if (cache.size === this.cacheSize) {
          //maps iterate entries and keys in insertion order - zero'th key should be oldest
          cache.delete(_toConsumableArray(cache.keys())[0]);
        }

        cache.set(graphqlQuery, promise);
      }
    }
  }, {
    key: "setResults",
    value: function setResults(promise, cacheKey, resp, err) {
      var cache = this._cache;

      if (this.noCaching) {
        return;
      } //cache may have been cleared while we were running. If so, we'll respect that, and not touch the cache, but
      //we'll still use the results locally


      if (cache.get(cacheKey) !== promise) return;

      if (err) {
        cache.set(cacheKey, {
          data: null,
          error: err
        });
      } else {
        if (resp.errors) {
          cache.set(cacheKey, {
            data: null,
            error: resp.errors
          });
        } else {
          cache.set(cacheKey, {
            data: resp.data,
            error: null
          });
        }
      }
    }
  }, {
    key: "getFromCache",
    value: function getFromCache(key, ifPending, ifResults, ifNotFound) {
      var cache = this._cache;

      if (this.noCaching) {
        ifNotFound();
      } else {
        var cachedEntry = cache.get(key);

        if (cachedEntry) {
          if (typeof cachedEntry.then === "function") {
            ifPending(cachedEntry);
          } else {
            //re-insert to put it at the fornt of the line
            cache.delete(key);
            this.set(key, cachedEntry);
            ifResults(cachedEntry);
          }
        } else {
          ifNotFound();
        }
      }
    }
  }, {
    key: "noCaching",
    get: function get() {
      return !this.cacheSize;
    }
  }, {
    key: "keys",
    get: function get() {
      return _toConsumableArray(this._cache.keys());
    }
  }, {
    key: "entries",
    get: function get() {
      return _toConsumableArray(this._cache);
    }
  }]);

  return Cache;
}();

var DEFAULT_CACHE_SIZE = 10;

var Client =
/*#__PURE__*/
function () {
  function Client() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      cacheSize: DEFAULT_CACHE_SIZE
    };

    _classCallCheck(this, Client);

    if (props.noCaching != null && props.cacheSize != null) {
      throw "Both noCaching, and cacheSize are specified. At most one of these options can be included";
    }

    if (props.noCaching) {
      props.cacheSize = 0;
    }

    Object.assign(this, props);
    this.caches = new Map([]);
    this.mutationListeners = new Set([]);
    this.forceListeners = new Map([]);
  }

  _createClass(Client, [{
    key: "getCache",
    value: function getCache(query) {
      return this.caches.get(query);
    }
  }, {
    key: "newCacheForQuery",
    value: function newCacheForQuery(query) {
      var newCache = new Cache(this.cacheSizeToUse);
      this.setCache(query, newCache);
      return newCache;
    }
  }, {
    key: "setCache",
    value: function setCache(query, cache) {
      this.caches.set(query, cache);
    }
  }, {
    key: "runQuery",
    value: function runQuery(query, variables) {
      return this.runUri(this.getGraphqlQuery({
        query: query,
        variables: variables
      }));
    }
  }, {
    key: "runUri",
    value: function runUri(uri) {
      return fetch(uri, this.fetchOptions || void 0).then(function (resp) {
        return resp.json();
      });
    }
  }, {
    key: "getGraphqlQuery",
    value: function getGraphqlQuery(_ref) {
      var query = _ref.query,
          variables = _ref.variables;
      return "".concat(this.endpoint, "?query=").concat(encodeURIComponent(query)).concat(typeof variables === "object" ? "&variables=".concat(encodeURIComponent(JSON.stringify(variables))) : "");
    }
  }, {
    key: "subscribeMutation",
    value: function subscribeMutation(subscription) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!Array.isArray(subscription)) {
        subscription = [subscription];
      }

      var packet = {
        subscription: subscription,
        options: options
      };

      if (!options.currentResults) {
        options.currentResults = function () {
          return {};
        };
      }

      this.mutationListeners.add(packet);
      return function () {
        return _this.mutationListeners.delete(packet);
      };
    }
  }, {
    key: "forceUpdate",
    value: function forceUpdate(query) {
      var updateListeners = this.forceListeners.get(query);

      if (updateListeners) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = updateListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var refresh = _step.value;
            refresh();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "registerQuery",
    value: function registerQuery(query, refresh) {
      var _this2 = this;

      if (!this.forceListeners.has(query)) {
        this.forceListeners.set(query, new Set([]));
      }

      this.forceListeners.get(query).add(refresh);
      return function () {
        return _this2.forceListeners.get(query).delete(refresh);
      };
    }
  }, {
    key: "processMutation",
    value: function processMutation(mutation, variables) {
      var _this3 = this;

      return Promise.resolve(this.runMutation(mutation, variables)).then(function (resp) {
        var mutationKeys = Object.keys(resp);
        var mutationKeysLookup = new Set(mutationKeys);

        _toConsumableArray(_this3.mutationListeners).forEach(function (_ref2) {
          var subscription = _ref2.subscription,
              _ref2$options = _ref2.options,
              currentResults = _ref2$options.currentResults,
              rest = _objectWithoutProperties(_ref2$options, ["currentResults"]);

          subscription.forEach(function (singleSubscription) {
            if (typeof singleSubscription.when === "string") {
              if (mutationKeysLookup.has(singleSubscription.when)) {
                singleSubscription.run(_objectSpread({
                  currentResults: currentResults()
                }, rest), resp, variables);
              }
            } else if (typeof singleSubscription.when === "object" && singleSubscription.when.test) {
              if (_toConsumableArray(mutationKeysLookup).some(function (k) {
                return singleSubscription.when.test(k);
              })) {
                singleSubscription.run(_objectSpread({
                  currentResults: currentResults()
                }, rest), resp, variables);
              }
            }
          });
        });

        return resp;
      });
    }
  }, {
    key: "runMutation",
    value: function runMutation(mutation, variables) {
      var _this$fetchOptions = this.fetchOptions,
          _this$fetchOptions$he = _this$fetchOptions.headers,
          headers = _this$fetchOptions$he === void 0 ? {} : _this$fetchOptions$he,
          otherOptions = _objectWithoutProperties(_this$fetchOptions, ["headers"]);

      return fetch(this.endpoint, _objectSpread({
        method: "post",
        headers: _objectSpread({
          Accept: "application/json",
          "Content-Type": "application/json"
        }, headers)
      }, otherOptions, {
        body: JSON.stringify({
          query: mutation,
          variables: variables
        })
      })).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: "cacheSizeToUse",
    get: function get() {
      if (this.cacheSize != null) {
        return this.cacheSize;
      }

      return DEFAULT_CACHE_SIZE;
    }
  }]);

  return Client;
}();

var DefaultClientManager = function DefaultClientManager() {
  var _this4 = this;

  _classCallCheck(this, DefaultClientManager);

  _defineProperty(this, "defaultClient", null);

  _defineProperty(this, "setDefaultClient", function (client) {
    return _this4.defaultClient = client;
  });

  _defineProperty(this, "getDefaultClient", function () {
    return _this4.defaultClient;
  });
};

var defaultClientManager = new DefaultClientManager();

function compress(strings) {
  for (var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    expressions[_key - 1] = arguments[_key];
  }

  return strings.map(function (string, i) {
    var expression = i < expressions.length ? expressions[i] : "";
    return string.replace(/\s+/g, " ").replace(/ ,/g, ",").replace(/, /g, ",").replace(/ :/g, ":").replace(/: /g, ":").replace(/{ /g, "{").replace(/} /g, "}").replace(/ {/g, "{").replace(/ }/g, "}").replace(/ \(/g, "(").replace(/ \)/g, ")").replace(/\( /g, "(").replace(/\) /g, ")") + expression;
  }).join("").trim();
}

var deConstructQueryPacket = function deConstructQueryPacket(packet) {
  if (typeof packet === "string") {
    return [packet, null, {}];
  } else if (Array.isArray(packet)) {
    return [packet[0], packet[1] || null, packet[2] || {}];
  }
};

var QueryManager =
/*#__PURE__*/
function () {
  function QueryManager(_ref3, packet) {
    var _this5 = this;

    var client = _ref3.client,
        setState = _ref3.setState,
        cache = _ref3.cache;

    _classCallCheck(this, QueryManager);

    _defineProperty(this, "mutationSubscription", null);

    _defineProperty(this, "currentState", _objectSpread({}, QueryManager.initialState));

    _defineProperty(this, "updateState", function (newState) {
      Object.assign(_this5.currentState, newState);

      _this5.setState(Object.assign({}, _this5.currentState));
    });

    _defineProperty(this, "refresh", function () {
      _this5.load();
    });

    _defineProperty(this, "softReset", function (newResults) {
      _this5.cache.clearCache();

      _this5.updateState({
        data: newResults
      });
    });

    _defineProperty(this, "hardReset", function () {
      _this5.cache.clearCache();

      _this5.reload();
    });

    _defineProperty(this, "clearCacheAndReload", function () {
      _this5.cache.clearCache();

      _this5.reload();
    });

    _defineProperty(this, "reload", function () {
      _this5.execute();
    });

    _defineProperty(this, "handleExecution", function (promise, cacheKey) {
      _this5.currentPromise = promise;
      Promise.resolve(promise).then(function (resp) {
        if (_this5.currentPromise !== promise) {
          return;
        }

        _this5.cache.setResults(promise, cacheKey, resp);

        if (resp.errors) {
          _this5.updateState({
            loaded: true,
            loading: false,
            data: null,
            error: resp.errors,
            currentQuery: cacheKey
          });
        } else {
          _this5.updateState({
            loaded: true,
            loading: false,
            data: resp.data,
            error: null,
            currentQuery: cacheKey
          });
        }
      }).catch(function (err) {
        _this5.cache.setResults(promise, cacheKey, null, err);

        _this5.updateState({
          loaded: true,
          loading: false,
          data: null,
          error: err,
          currentQuery: cacheKey
        });
      });
    });

    var _deConstructQueryPack = deConstructQueryPacket(packet),
        _deConstructQueryPack2 = _slicedToArray(_deConstructQueryPack, 3),
        query = _deConstructQueryPack2[0],
        variables = _deConstructQueryPack2[1],
        options = _deConstructQueryPack2[2];

    this.client = client;
    this.setState = setState;
    this.cache = cache || client.getCache(query) || client.newCacheForQuery(query);
    this.unregisterQuery = this.client.registerQuery(query, this.refresh);

    if (typeof options.onMutation === "object") {
      if (!Array.isArray(options.onMutation)) {
        options.onMutation = [options.onMutation];
      }

      this.mutationSubscription = this.client.subscribeMutation(options.onMutation, {
        cache: this.cache,
        softReset: this.softReset,
        hardReset: this.hardReset,
        refresh: this.refresh,
        currentResults: function currentResults() {
          return _this5.currentState.data;
        }
      });
    }

    this.currentState.reload = this.reload;

    this.currentState.clearCache = function () {
      return _this5.cache.clearCache();
    };

    this.currentState.clearCacheAndReload = this.clearCacheAndReload;
  }

  _createClass(QueryManager, [{
    key: "load",
    value: function load(packet, force) {
      var _this6 = this;

      if (packet) {
        var _deConstructQueryPack3 = deConstructQueryPacket(packet),
            _deConstructQueryPack4 = _slicedToArray(_deConstructQueryPack3, 2),
            query = _deConstructQueryPack4[0],
            variables = _deConstructQueryPack4[1];

        var _graphqlQuery = this.client.getGraphqlQuery({
          query: query,
          variables: variables
        });

        if (force || _graphqlQuery != this.currentUri) {
          this.currentUri = _graphqlQuery;
        } else {
          return;
        }
      }

      var graphqlQuery = this.currentUri;
      this.cache.getFromCache(graphqlQuery, function (promise) {
        Promise.resolve(promise).then(function () {
          //cache should now be updated, unless it was cleared. Either way, re-run this method
          _this6.load();
        });
      }, function (cachedEntry) {
        _this6.updateState({
          data: cachedEntry.data,
          error: cachedEntry.error,
          loading: false,
          loaded: true,
          currentQuery: graphqlQuery
        });
      }, function () {
        return _this6.execute();
      });
    }
  }, {
    key: "execute",
    value: function execute() {
      var graphqlQuery = this.currentUri;
      this.updateState({
        loading: true
      });
      var promise = this.client.runUri(this.currentUri);
      this.cache.setPendingResult(graphqlQuery, promise);
      this.handleExecution(promise, graphqlQuery);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.mutationSubscription && this.mutationSubscription();
      this.unregisterQuery();
    }
  }]);

  return QueryManager;
}();

_defineProperty(QueryManager, "initialState", {
  loading: false,
  loaded: false,
  data: null,
  error: null
});

var deConstructMutationPacket = function deConstructMutationPacket(packet) {
  if (typeof packet === "string") {
    return [packet];
  } else if (Array.isArray(packet)) {
    return [packet[0]];
  }
};

var MutationManager = function MutationManager(_ref4, packet) {
  var _this7 = this;

  var client = _ref4.client,
      setState = _ref4.setState;

  _classCallCheck(this, MutationManager);

  _defineProperty(this, "runMutation", function (variables) {
    _this7.setState({
      running: true,
      finished: false,
      runMutation: _this7.runMutation
    });

    return _this7.client.processMutation(_this7.mutation, variables).then(function (resp) {
      _this7.setState({
        running: false,
        finished: true,
        runMutation: _this7.runMutation
      });

      return resp;
    });
  });

  _defineProperty(this, "currentState", _objectSpread({}, MutationManager.initialState, {
    runMutation: this.runMutation
  }));

  _defineProperty(this, "updateState", function () {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(_this7.currentState, newState);

    _this7.setState(_this7.currentState);
  });

  var _deConstructMutationP = deConstructMutationPacket(packet),
      _deConstructMutationP2 = _slicedToArray(_deConstructMutationP, 1),
      mutation = _deConstructMutationP2[0];

  this.client = client;
  this.setState = setState;
  this.mutation = mutation;
};

_defineProperty(MutationManager, "initialState", {
  running: false,
  finished: false
});

var GraphQL =
/*#__PURE__*/
function (_Component) {
  _inherits(GraphQL, _Component);

  _createClass(GraphQL, [{
    key: "client",
    get: function get() {
      return this.props.client || defaultClientManager.getDefaultClient();
    }
  }]);

  function GraphQL(props) {
    var _this8;

    _classCallCheck(this, GraphQL);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(GraphQL).call(this, props));

    _defineProperty(_assertThisInitialized(_this8), "queryManagerMap", {});

    _defineProperty(_assertThisInitialized(_this8), "mutationManagerMap", {});

    _this8.state = {
      queries: {},
      mutations: {}
    };
    var _this8$props = _this8.props,
        _this8$props$query = _this8$props.query,
        query = _this8$props$query === void 0 ? {} : _this8$props$query,
        _this8$props$mutation = _this8$props.mutation,
        mutation = _this8$props$mutation === void 0 ? {} : _this8$props$mutation;
    Object.keys(query).forEach(function (k) {
      var packet = query[k];

      var setState = function setState(state) {
        _this8.setState(function (oldState) {
          return {
            queries: _objectSpread({}, oldState.queries, _defineProperty2({}, k, state))
          };
        });
      };

      var options = packet[2] || {};
      _this8.queryManagerMap[k] = new QueryManager({
        client: options.client || _this8.client,
        setState: setState,
        cache: options.cache
      }, packet);
      _this8.state.queries[k] = _this8.queryManagerMap[k].currentState;
    });
    Object.keys(mutation).forEach(function (k) {
      var packet = mutation[k];

      var setState = function setState(state) {
        _this8.setState(function (oldState) {
          return {
            mutations: _objectSpread({}, oldState.mutations, _defineProperty2({}, k, state))
          };
        });
      };

      var options = packet[1] || {};
      _this8.mutationManagerMap[k] = new MutationManager({
        client: options.client || _this8.client,
        setState: setState
      }, packet);
      _this8.state.mutations[k] = _this8.mutationManagerMap[k].currentState;
    });
    return _this8;
  }

  _createClass(GraphQL, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this9 = this;

      var _this$props = this.props,
          _this$props$query = _this$props.query,
          query = _this$props$query === void 0 ? {} : _this$props$query,
          _this$props$mutation = _this$props.mutation,
          mutation = _this$props$mutation === void 0 ? {} : _this$props$mutation;
      Object.keys(query).forEach(function (k) {
        return _this9.loadIfActive(k, true);
      });
      Object.keys(mutation).forEach(function (k) {
        return _this9.mutationManagerMap[k].updateState();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this10 = this;

      var _this$props$query2 = this.props.query,
          query = _this$props$query2 === void 0 ? {} : _this$props$query2;
      Object.keys(query).forEach(function (k) {
        return _this10.loadIfActive(k);
      });
    }
  }, {
    key: "loadIfActive",
    value: function loadIfActive(key, force) {
      var packet = this.props.query[key];
      var options = packet[2] || {};

      if (!("active" in options) || options.active) {
        var queryManager = this.queryManagerMap[key];
        queryManager.load(packet, force);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this11 = this;

      Object.keys(this.queryManagerMap).forEach(function (k) {
        return _this11.queryManagerMap[k].dispose();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children ? children(_objectSpread({}, this.state.queries, this.state.mutations)) : null;
    }
  }]);

  return GraphQL;
}(Component);

var useState = React.useState,
    useRef = React.useRef,
    useLayoutEffect = React.useLayoutEffect;

function useQuery(packet) {
  var _packet = _slicedToArray(packet, 3),
      query = _packet[0],
      variables = _packet[1],
      _packet$ = _packet[2],
      options = _packet$ === void 0 ? {} : _packet$;

  var client = options.client || defaultClientManager.getDefaultClient();

  var _useState = useState(QueryManager.initialState),
      _useState2 = _slicedToArray(_useState, 2),
      queryState = _useState2[0],
      setQueryState = _useState2[1];

  var queryManager = useRef(null);
  useLayoutEffect(function () {
    if ("active" in options && !options.active) {
      return;
    }

    if (!queryManager.current) {
      queryManager.current = new QueryManager({
        client: client,
        cache: options.cache,
        setState: setQueryState
      }, packet);
    }

    queryManager.current.load(packet);
  });
  useLayoutEffect(function () {
    return function () {
      return queryManager.current && queryManager.current.dispose();
    };
  }, []);
  return queryState;
}

var useState$1 = React.useState,
    useRef$1 = React.useRef,
    useMemo = React.useMemo,
    useLayoutEffect$1 = React.useLayoutEffect;

function useMutation(packet) {
  var _packet2 = _slicedToArray(packet, 2),
      mutation = _packet2[0],
      _packet2$ = _packet2[1],
      options = _packet2$ === void 0 ? {} : _packet2$;

  var _useState$ = useState$1(null),
      _useState$2 = _slicedToArray(_useState$, 2),
      mutationState = _useState$2[0],
      setMutationState = _useState$2[1];

  var client = options.client || defaultClientManager.getDefaultClient();
  var mutationManagerRef = useRef$1(null);

  if (!mutationManagerRef.current) {
    mutationManagerRef.current = new MutationManager({
      client: client,
      setState: setMutationState
    }, packet);
    mutationManagerRef.current.updateState();
  }

  useLayoutEffect$1(function () {
    return function () {
      return mutationManagerRef.current.setState = function () {};
    };
  }, []);
  return mutationState || mutationManagerRef.current.currentState;
}

var buildQuery = function buildQuery(queryText, variables, options) {
  return [queryText, variables, options];
};

var buildMutation = function buildMutation(mutation, options) {
  return [mutation, options];
};

var setDefaultClient = defaultClientManager.setDefaultClient,
    getDefaultClient = defaultClientManager.getDefaultClient;
export { Client, compress, setDefaultClient, getDefaultClient, GraphQL, buildQuery, buildMutation, Cache, useQuery, useMutation };